import AxiosInstance from "service/axiosInstance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useToast } from "hooks";

const KEY = "devices";

const getAll = () => AxiosInstance({ method: "GET", url: "api/v1/device" });
const create = (data) => AxiosInstance({ method: "POST", url: "api/v1/device", data });
const update = ({ id, ...data }) => AxiosInstance({ method: "PATCH", url: `api/v1/device/${id}`, data });
const toggleVisibility = (id) => AxiosInstance({ method: "PATCH", url: `api/v1/device/${id}/toggle-visibility` });
const remove = (id) => AxiosInstance({ method: "DELETE", url: `api/v1/device/${id}` });

export const useGetDevices = () =>
  useQuery({ queryKey: [KEY], queryFn: getAll, staleTime: 0 });

export const useCreateDevice = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(create, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("Device created"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useUpdateDevice = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(update, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("Device updated"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useToggleDevice = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(toggleVisibility, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("Visibility updated"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

export const useDeleteDevice = () => {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation(remove, {
    onSuccess: () => { qc.invalidateQueries([KEY]); toast.toastSuccess("Device deleted"); },
    onError: (e) => toast.toastError(e?.message || "Failed"),
  });
};

const getActive = () => AxiosInstance({ method: "GET", url: "api/v1/device/active" });

export const useGetActiveDevices = () =>
  useQuery({ queryKey: [KEY, "active"], queryFn: getActive, staleTime: 0 });
